import React, { useState, useEffect } from 'react';
import FallingLeaves from './FallingLeaves';
import HalloweenCreatures from './HalloweenCreatures';
import HalloweenDecorations from './HalloweenDecorations';

const HalloweenTheme = () => {
  const [isHalloweenSeason, setIsHalloweenSeason] = useState(false);

  useEffect(() => {
    const checkHalloweenSeason = () => {
      const now = new Date();
      const year = now.getFullYear();

      // Halloween season: October 1st to October 31st (inclusive)
      const seasonStart = new Date(year, 9, 1); // Month is 0-indexed, so 9 = October
      const seasonEnd = new Date(year, 10, 1); // November 1st 00:00 (so 31st is included)

      setIsHalloweenSeason(now >= seasonStart && now < seasonEnd);
    };

    checkHalloweenSeason();

    // Check hourly in case the page is left open past midnight on the 31st
    const interval = setInterval(checkHalloweenSeason, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, []);

  if (!isHalloweenSeason) {
    return null;
  }

  return (
    <>
      <FallingLeaves />
      <HalloweenCreatures />
      <HalloweenDecorations />
    </>
  );
};

export default HalloweenTheme;
